import styled from 'styled-components';

// Free-floating card anchored at a screen coordinate (the clicked cluster
// badge). Unlike AnnotationClusterMarker's Popover, this is position: fixed so
// it can be driven by the D3 trend chart, which has no React marker container.
export const PopoverCard = styled.div`
  position: fixed;
  transform: translate(-50%, 10px);
  z-index: 1000;
  min-width: 280px;
  max-width: 360px;
  max-height: 320px;
  overflow-y: auto;
  background: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.greyXXD};
  border: 1px solid ${props => props.theme.colors.greyL};
  border-radius: ${props => props.theme.utils.borderRadius};
  padding: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  pointer-events: auto;
`;

export const PopoverHeader = styled.div`
  padding: 4px 8px 10px;
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${props => props.theme.colors.textSecondary};
  border-bottom: 1px solid ${props => props.theme.colors.greyXXXL};
`;

// Title fills the row and may wrap to two lines; the range sits flush-right.
export const RowTitle = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
`;

export const RowRange = styled.span`
  flex: 0 0 auto;
  margin-left: auto;
  padding-left: 12px;
  align-self: flex-start;
  font-size: 12px;
  white-space: nowrap;
  color: ${props => props.theme.colors.textSecondary};
`;
